import { RegistrationAction, RegistrationState } from '@/types/pages/storeManagement/registration/registrationTypes';
import { createContext, useContext } from 'react';

type RegistrationContextType = {
    state: RegistrationState;
    dispatch: React.Dispatch<RegistrationAction>;
};

export const RegistrationContext = createContext<RegistrationContextType | null>(null);

export const useRegistrationState = () => {
    const context = useContext(RegistrationContext);
    if (!context) {
        throw new Error('useRegistrationState must be used within a RegistrationProvider');
    }
    return context;
};
